// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".timepicker-dropdown .dropdown-menu.dialog{max-width:250px !important}.timepicker-dropdown .dropdown__toggle{display:flex;justify-content:space-between;border-radius:4px !important}.timepicker-dropdown .dropdown__toggle:hover{border:1px solid #282f3a !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
